import { env } from '@/lib/env';
import { cn } from '@iq/ui';
import { useTranslation } from 'react-i18next';

export interface KbImageProps {
  docId: string;
  imageRef: string;
  alt?: string;
  className?: string;
}

export function KbImage({ docId, imageRef, alt, className }: KbImageProps) {
  const { t } = useTranslation();
  const src = `${env.VITE_API_BASE_URL}/images/${encodeURIComponent(docId)}/${encodeURIComponent(imageRef)}`;
  return (
    <img
      src={src}
      alt={alt ?? t('chat.citation.imageAlt')}
      loading="lazy"
      className={cn('max-w-full rounded-md border bg-muted/30', className)}
      data-testid={`kb-image-${docId}-${imageRef}`}
    />
  );
}
